export default __webpack_public_path__ + "static/media/flechaIzq.a18eb05f.svg";